<template>
  <div>
    <b-tabs v-model="activeTab" content-class="mt-4" nav-class="border-0">
      <b-tab title="Member Mobile Apps" active>
        <MemberTable />
      </b-tab>
      <b-tab title="Transaksi Mobile Apps">
        <TransactionTable />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import MemberTable from "./MemberTable.vue";
import TransactionTable from "./Table.vue";

export default {
  components: {
    MemberTable,
    TransactionTable,
  },
  data: () => ({
    // 0 = Member Mobile Apps (daftar member yang registrasi via aplikasi Kai Fit),
    // 1 = Transaksi Mobile Apps (proses verifikasi pembayaran yang sudah ada).
    activeTab: 0,
  }),
};
</script>
